import { render } from "./RoleSelectView.vue?vue&type=template&id=2e185307&scoped=true"
import script from "./RoleSelectView.vue?vue&type=script&lang=js"
export * from "./RoleSelectView.vue?vue&type=script&lang=js"

import "./RoleSelectView.vue?vue&type=style&index=0&id=2e185307&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e185307"]])

export default __exports__